// extracted by mini-css-extract-plugin
export default {"heading":"RequestTypeForm_heading__DajfS","subHeading":"RequestTypeForm_subHeading__5eRyC","listItem":"RequestTypeForm_listItem__hR5lr","input":"RequestTypeForm_input__Z9+n3"};